import {
	requests
}from '../../../../api/agent'

export default {
	getPagedAll   : (params) => requests.getWithParams('/ReAddress/GetPagedAll', params),
	getPaged      : (params) => requests.getWithParams('/ReAddress/GetPaged', params),
	getList       : (params) => requests.getWithParams('/ReAddress/GetList', params),
	getPagedAudit : (params) => requests.getWithParams('/ReAddress/getPagedAudit', params),
	create        : (params) => requests.post('/ReAddress/Create', params),
	delete        : (params) => requests.getWithParams('/ReAddress/Delete', params),
	update        : (params) => requests.post('/ReAddress/Update', params),
	restore       : (params) => requests.getWithParams('/ReAddress/Restore', params)
}